import { TypographyV3 } from '@jouzen/ecom-components';
import { useFeatureGate } from '@statsig/react-bindings';
import { useTranslations } from 'next-intl';

const HSAFSAContent = (): JSX.Element => {
  const hsaFsaGate = useFeatureGate('hsafsa_rollout').value;
  const t = useTranslations();

  return (
    <>
      {hsaFsaGate ? (
        <TypographyV3 className="border-b border-sandstone-500/50 pb-5 text-base font-medium">
          {t('bundle_modal_subtext_hsa_fsa')}
        </TypographyV3>
      ) : (
        <TypographyV3 className="border-b border-sandstone-500/50 pb-5 text-base font-medium">
          {t('bundle_modal_subtext')}
        </TypographyV3>
      )}
    </>
  );
};

export default HSAFSAContent;
